<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="order-page-main-sec track-order-main-sec order-detail-main-sec edit-order-detail-main-sec agency-design-grid-right missed-opportunitie-page-sec edited-order-links-page-sec"
    >
      <div class="invoice-history-content">
        <div class="text-1">Order ID</div>
        <h2 class="text-heading">{{ orderID }}</h2>
      </div>

      <div class="editor-dashboard-sec-2">
        <div class="order-list-tabs">
          <div class="back-btn">
            <router-link to="/order-opprovals"
              ><i class="fas fa-arrow-alt-circle-left"></i
            ></router-link>
          </div>
          <ul>
            <li>
              <div class="text-1">
                Old Price <b>{{ numberFormat(existingPrice, "currency") }}</b>
              </div>
            </li>
            <li>
              <div class="text-1">
                New Price <b>{{ numberFormat(newPrice, "currency") }}</b>
              </div>
            </li>
            <li>
              <div class="text-1">
                Balance Amount
                <b class="remaining-color"
                  >{{ numberFormat(priceDiff, "currency") }}</b
                >
              </div>
            </li>
          </ul>
        </div>

        <EditedlinksView
          v-if="edited_order_links.length > 0"
          :editLinks="edited_order_links"
          :groupedLinks="groupedLinks"
          :PPOrder="PPOrder"
          :mediaLinks="mediaLinks"
          @openOrderSidebar="openOrderSidebar"
        />
 <div
        class="email-sideabar-box missedOpportunity-sideabar-box"
        :class="{ openOpportunitySidebar: orderSidebarOpen }"
      >
        <div class="top-bar">
          <div class="text-heading">Updated Link Details</div>
          <div class="icon-box">
            <i class="fas fa-times" @click="closeOrderSidebar"></i>
          </div>
        </div>
          <EditedLinksSidebarView :activeLink="activeLink"></EditedLinksSidebarView>

      </div>

        <div class="btn-box-list" v-if="existingPrice > 0 || newPrice > 0">
          <a
            v-if="existingPrice > newPrice"
            href="javascript:;"
            class="btn-1"
            @click="addBalanceAmountPopup"
            >Add to wallet
          </a>
          <a
            v-else-if="existingPrice == newPrice"
            href="javascript:;"
            class="btn-1"
            @click="approveOrderPopup"
            >Approve
          </a>
          <a v-else href="javascript:;" class="btn-1" @click="proceed">Proceed to Pay </a>
        </div>

        <div class="total-records-list">
          <p>
            Showing {{ rows }} of
            {{ totalRecords }} records
          </p>
        </div>
      </div>

      <div class="pagination-list">
        <paginate
          :click-handler="getEditOrderLinks"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :page-count="filter.last_page"
          :page-range="3"
          :margin-pages="2"
          :container-class="'className'"
          :records="filter.length"
          v-model="filter.page"
          :per-page="filter.per_page"
        >
        </paginate>
      </div>
                <!-- <div
        class="email-sideabar-box missedOpportunity-sideabar-box"
        :class="{ openOpportunitySidebar: isSidebarOpen }"
      >
        <div class="top-bar">
          <div class="text-heading"></div>
          <div class="icon-box">
            <i class="fas fa-times" @click="closeOpportunitySidebar"></i>
          </div>
        </div>
        <EditedLinksSidebarView
          @openSidebar="openSidebar"
        ></EditedLinksSidebarView>
      </div> -->
    </section>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import EditedlinksView from "@/components/editOrderLinksComponents/EditedLinks.vue";
import EditedLinksSidebarView from "@/components/editOrderLinksComponents/EditedLinksDetailComponent.vue";
import { numberFormat } from "@/prod.js";
import Paginate from "vuejs-paginate-next";
import LZString from "lz-string";
import swal from "sweetalert2";
// import DatePickerComponent from "@/components/DatePickerComponent.vue";
const toast = useToast();

export default {
  components: {
    // DatePickerComponent,
    HeaderView,
    LoaderComponent,
    EditedlinksView,
    EditedLinksSidebarView,
    Paginate,
  },
  mounted() {
    this.getOrderId();
    localStorage.removeItem("editedOrder");
    localStorage.removeItem("order-total");
    localStorage.removeItem("link-ids");
    localStorage.removeItem("editedOrderId");
    localStorage.removeItem("new-price");
    localStorage.removeItem("grouped-links");
  },
  data() {
    return {
      numberFormat,
      LZString,
      loading: false,
      date: new Date(),
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false,
      },
      order_date: "",
      minDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
      filter: {
        s: "",
        e: "",
        columnTo: "id",
        orderBy: "desc",
        per_page: 50,
        page: 1,
        last_page: 1,
        length: "",
        id: "",
      },
      totalRecords: 0,
      rows: [],
      paginationData: {},
      edited_order_links: [],
      selectedRange: "",
      links: {},
          isSidebarOpen: false,
      ranges: {
        Today: [new Date(), new Date()],
        Yesterday: [
          new Date(new Date().setDate(new Date().getDate() - 1)),
          new Date(new Date().setDate(new Date().getDate() - 1)),
        ],
        "Last 7 Days": [
          new Date(new Date().setDate(new Date().getDate() - 7)),
          new Date(),
        ],
        "Last 30 Days": [
          new Date(new Date().setDate(new Date().getDate() - 30)),
          new Date(),
        ],
        "This Month": [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(),
        ],
        "Last Month": [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        ],
        "This Year": [new Date(new Date().getFullYear(), 0, 1), new Date()],
        "Custom Range": [new Date(), new Date()],
      },
      position: "left",
      existingPrice: 0,
      newPrice: 0,
      priceDiff: 0,
      links_ids: [],
      editedOrder: true,
      orderSidebarOpen: false,
      orderSidebarClose: true,
      orderID: '',
      activeLink: [],
      PPOrder: false,
      mediaLinks: false,
    };
  },
  methods: {

    getOrderId(){
      var url = window.location.pathname;
      var id = url.substring(url.lastIndexOf('/') + 1);
      if (id) {
        this.filter.id = decodeURIComponent(id);
        this.getEditOrderLinks();
      }else{
        this.$router.push("/dashboard");
      }
    },

    getSearchData(value) {
      this.order_date = value;
      this.getEditedOrderSearch();
    },

    async getEditOrderLinks() {
      this.loading = true;
      this.filter.s = this.order_date ? this.order_date[0] : "";
      this.filter.e = this.order_date ? this.order_date[1] : "";
      try {
        let res = await this.$store.dispatch(
          "Product/getEditOrderLinksAction",
          this.filter
        );
        this.orderID = res.data.orderId;
        if(res.data.orderId == ""){
          this.$router.push("/dashboard");
        }
        this.edited_order_links = res.data['links'];
        this.PPOrder = res.data['links'][0].missed_opportunities;
        this.mediaLinks = res.data['links'][0].mediaLinks;
        this.existingPrice = res.data['price'].oldPrice;
        this.newPrice = res.data['price'].newPrice;
        this.priceDiff = res.data['price'].priceDiff;
        this.paginationData = res;
        this.totalRecords = res.meta.total;
        this.rows = new Set(res.data['links'].map(item => item.link_id)).size;
        this.filter.page = res.meta.current_page;
        this.filter.per_page = res.meta.per_page;
        this.filter.last_page = res.meta.last_page;
        this.filter.length = res.meta.total;
        this.calculateAmount();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

   openOpportunitySidebar(id) {
      var arr = this.missed_opportunities;
      arr = arr.filter((x) => x.id === id);
      this.opportunityDetail = arr[0];
      setTimeout(() => (this.isSidebarOpen = true), 500);
      setTimeout(() => (this.isSidebarClose = false), 500);
    },

    closeOpportunitySidebar() {
      setTimeout(() => (this.isSidebarOpen = false), 500);
    },

    isAddonValuePresent(value) {
      const raw = String(value ?? "").trim();
      if (!raw) return false;
      const normalized = raw.toLowerCase();
      return !["none", "n/a", "na", "null", "undefined", "0", "false", "-"].includes(normalized);
    },
    parseAddonCost(value) {
      if (typeof value === "number") return Number.isFinite(value) ? value : 0;
      const raw = String(value ?? "").trim();
      if (!raw) return 0;
      const cleaned = raw.replace(/,/g, "").replace(/[^\d.-]/g, "");
      const n = Number(cleaned);
      return Number.isFinite(n) ? n : 0;
    },
    splitValueAndPrice(value) {
      const raw = String(value ?? "").trim();
      if (!raw) return { cleanValue: "", inlineCost: 0 };
      const m = raw.match(/^(.*)\(\s*\$?\s*([\d,]+(?:\.\d+)?)\s*\)\s*$/);
      if (!m) return { cleanValue: raw, inlineCost: 0 };
      return {
        cleanValue: String(m[1] || "").trim(),
        inlineCost: this.parseAddonCost(m[2]),
      };
    },
    mapAddonTitle(name) {
      const n = String(name ?? "").trim().toLowerCase();
      if (n.includes("minimum traffic")) return "Minimum Traffic";
      if (n.includes("content approval")) return "Content Approval";
      if (n === "country" || n.includes("uk tld")) return "Country";
      if (n.includes("traffic stability")) return "Traffic Stability";
      if (n.includes("spam score")) return "Spam Score";
      if (n.includes("rd:ld ratio")) return "RD:LD Ratio";
      if (n.includes("cf:tf ratio")) return "CF:TF Ratio";
      if (n.includes("niche purity")) return "Niche Purity";
      return String(name || "Add-On").trim();
    },
    normalizeAddonValue(title, value) {
      const t = String(title ?? "").toLowerCase();
      const raw = String(value ?? "").trim();
      if (t.includes("traffic stability")) {
        if (/\b12\b/i.test(raw)) return raw.replace(/12\s*month\s*stable\s*traffic/gi, "12mo");
        if (/\b6\b/i.test(raw)) return raw.replace(/6\s*month\s*stable\s*traffic/gi, "6mo");
      }
      if (t.includes("spam score")) {
        return raw.replace(/less\s*than\s*/gi, "< ");
      }
      return raw;
    },
    buildAddonText(name, value, cost = 0) {
      if (!this.isAddonValuePresent(name) || !this.isAddonValuePresent(value)) return null;
      const title = this.mapAddonTitle(name);
      const { cleanValue, inlineCost } = this.splitValueAndPrice(value);
      const finalValue = this.normalizeAddonValue(title, cleanValue || value);
      const finalCost = this.parseAddonCost(cost) || inlineCost;
      const priceText = finalCost > 0 ? ` (${this.numberFormat(finalCost, "currency")})` : "";
      return `${title}: ${finalValue}${priceText}`;
    },
    parseLinkAddons(link) {
      let rows = link?.addons;
      if (typeof rows === "string") {
        try {
          rows = JSON.parse(rows);
        } catch {
          rows = [];
        }
      }
      return Array.isArray(rows) ? rows : [];
    },
    getEditedLinkAddonItems(link) {
      const type = String(link?.type || "").trim().toLowerCase();
      if (type !== "new" && type !== "updated") return [];
      return this.getAddonItemsForLink(link);
    },
    getEditedLinkOldAddonItems(link) {
      const type = String(link?.type || "").trim().toLowerCase();
      if (type !== "old") return [];
      return this.getAddonItemsForLink(link);
    },
    getAddonItemsForLink(link) {
      const type = String(link?.type || "").trim().toLowerCase();
      const isUpdatedType = type === "new" || type === "updated";
      const isOldType = type === "old";

      const items = [];
      const push = (name, value, cost = 0) => {
        const text = this.buildAddonText(name, value, cost);
        if (text && !items.includes(text)) items.push(text);
      };

      this.parseLinkAddons(link).forEach((a) => {
        if (typeof a === "string") {
          const text = a.trim();
          if (text && !items.includes(text)) items.push(text);
          return;
        }
        push(
          a?.addon_name || a?.name,
          a?.value || a?.option || a?.selected || a?.name,
          a?.cost ?? a?.price ?? a?.amount
        );
      });

      if (isUpdatedType || isOldType) {
        push("Minimum Traffic", link?.minimum_traffic, link?.minimum_traffic_cost);
        push("Content Approval", link?.content_approval, link?.content_approval_cost);
        push("Country", link?.uk_tld, link?.uk_tld_cost);
      }

      return items;
    },

    calculateAmount(){
      this.edited_order_links.forEach((d) => {
          // if(d.type == 'Old'){
          //   this.existingPrice += d.price;
          // }
          // else if(d.type == 'Updated'){
          //   this.newPrice += d.price;
          // }
          if (!this.links_ids.includes(d.link_id)) {
            this.links_ids.push(d.link_id);
          }
      });
          // this.priceDiff = (this.newPrice - this.existingPrice);
    },

    addBalanceAmountPopup(){
      swal.fire({
        title: 'Are you sure?',
        text: "On click proceed your amount added!",
        icon: 'warning',
        width: 600,
        showCancelButton: true,
        confirmButtonColor: '#00b6cb',
        cancelButtonColor: '#ff0e52',
        confirmButtonText: 'Proceed'
      }).then((result) => {
        if (result.isConfirmed) {
          this.addBalanceAmount();
        }
      });
    },

    async addBalanceAmount(){
      this.loading = true;
      try {
        let res = await this.$store.dispatch("Product/addOrderBalanceAction",
          { 
            'id' : this.filter.id,
            'balance' : Math.abs(this.priceDiff),
            'link_ids' : this.links_ids,
            'newPrice' : this.newPrice,
            'addBalance' : true
          },
          {
            root: true,
          });
        if (res.success) {
          this.loading = false;
          toast.success(res.message, { timeout: 3000 });
          this.$router.push("/order-opprovals");
        }
      } catch (e) {
        this.loading = false;
        toast.error(e.response.data.message, {
          timeout: 3000,
        });
      }
    },
  
    proceed(){
      // Per-tab flow marker (sessionStorage is tab-scoped).
      sessionStorage.setItem("payment-flow-type", "edited");
      localStorage.setItem("order-total", this.priceDiff);
      localStorage.setItem("link-ids", LZString.compress(JSON.stringify(this.links_ids)));
      localStorage.setItem("editedOrderId", this.filter.id);
      localStorage.setItem("editedOrder", this.editedOrder);
      localStorage.setItem("new-price", this.newPrice);
      localStorage.setItem("old-price", this.existingPrice);
      localStorage.setItem("grouped-links", LZString.compress(JSON.stringify(this.groupedLinks)));
      localStorage.setItem("edit-pp-order", this.PPOrder);
      // Dedicated edited-order keys so normal order-summary cleanup cannot break edited flow in another tab.
      localStorage.setItem("edited-order-total", this.priceDiff);
      localStorage.setItem("edited-link-ids", LZString.compress(JSON.stringify(this.links_ids)));
      localStorage.setItem("edited-order-id", this.filter.id);
      localStorage.setItem("edited-order-flag", this.editedOrder);
      localStorage.setItem("edited-new-price", this.newPrice);
      localStorage.setItem("edited-old-price", this.existingPrice);
      localStorage.setItem("edited-grouped-links", LZString.compress(JSON.stringify(this.groupedLinks)));
      localStorage.setItem("edited-pp-order", this.PPOrder);
      localStorage.setItem("edited-media-links", this.mediaLinks ? "true" : "false");
      // this.$router.push("/order-summary");
      this.$router.push({
        path: "/edited-order-summary",
        query: this.$route.query
      });
    },

    approveOrderPopup(){
      swal.fire({
        title: 'Are you sure?',
        // text: "On click approve, your amount added!",
        icon: 'warning',
        width: 600,
        showCancelButton: true,
        confirmButtonColor: '#00b6cb',
        cancelButtonColor: '#ff0e52',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          this.approveOrder();
        }
      });
    },

    async approveOrder(){
      this.loading = true;
      try {
        let res = await this.$store.dispatch("Product/approveEditedOrderAction",
          { 
            'id' : this.filter.id,
            'link_ids' : this.links_ids,
            'newPrice' : this.newPrice,
            'addBalance' : false
          },
          {
            root: true,
          });
        if (res.success) {
          this.loading = false;
          toast.success(res.message, { timeout: 3000 });
          this.$router.push("/order-opprovals");
        }
      } catch (e) {
        this.loading = false;
        toast.error(e.response.data.message, {
          timeout: 3000,
        });
      }
    },

    changePagination() {
      this.filter.page = 1;
      this.getEditedOrder();
    },

    getEditedOrderSearch() {
      this.filter.page = 1;
      this.getEditedOrder();
    },

    sortByColumn(column) {
      this.filter.columnTo = column;
      this.filter.orderBy = this.filter.orderBy == "asc" ? "desc" : "asc";
      this.getEditedOrder();
    },

     openOrderSidebar(linksDetail) {
      this.activeLink = linksDetail;
      setTimeout(() => (this.orderSidebarOpen = true), 500);
      console.log(this.orderSidebarOpen);
      setTimeout(() => (this.orderSidebarClose = false), 500);
    },

    closeOrderSidebar() {
      setTimeout(() => (this.orderSidebarOpen = false), 500);
    },
  },
   computed: {
    groupedLinks() {
      const grouped = {};

      this.edited_order_links.forEach((link) => {
        if (!grouped[link.link_id]) {
          grouped[link.link_id] = {
            link_id: link.link_id,
            ids: [link.id],
            types: [link.type],
            texts: [link.text],
            product_names: [link.product_name],
            primary_categories: [link.primary_category],
            urls: [link.url],
            secondary_categories: [link.secondary_category],
            addons_counts: [link.addons_count],
            prices: [link.price],
            // statuses: [link.status],
            statuses: ['On Hold'],
            minimum_traffic_addon: [link.minimum_traffic],
            content_approval_addon: [link.content_approval],
            uk_tld_addon: [link.uk_tld],
            missed_opportunities: [link.missed_opportunities],
            do_follow: [link.do_follow],
            traffic: [link.traffic],
            spam_score: [link.spam_score],
            exact_da: [link.exact_da],
            exact_dr: [link.exact_dr],
            packageOrder: [link.packageOrder],
            live_link: [link.live_link],
            publish_date: [link.publish_date],
            mo_order_type: [link.mo_order_type],
            placement_authority: [link.placement_authority == null ? 'N/A' : link.placement_authority],
            addon_items: this.getEditedLinkAddonItems(link),
            old_addon_items: this.getEditedLinkOldAddonItems(link),
            authority: [link.authority],
            location: [link.location],
            sample_post: [link.sample_post],
            rel_attribute: [link.rel_attribute],
            sponsored_tag: [link.sponsored_tag],
            turnaround_time: [link.turnaround_time],
            industry: [link.industry],
          };
        } else {
          grouped[link.link_id].ids.push(link.id);
          if (!grouped[link.link_id].types.includes(link.type)) {
            grouped[link.link_id].types.push(link.type);
          }
          if (!grouped[link.link_id].texts.includes(link.text)) {
            grouped[link.link_id].texts.push(link.text);
          }
          if (!grouped[link.link_id].product_names.includes(link.product_name)) {
            grouped[link.link_id].product_names.push(link.product_name);
          }
          if (!grouped[link.link_id].primary_categories.includes(link.primary_category)) {
            grouped[link.link_id].primary_categories.push(link.primary_category);
          }
          if (!grouped[link.link_id].urls.includes(link.url)) {
            grouped[link.link_id].urls.push(link.url);
          }
          if (!grouped[link.link_id].secondary_categories.includes(link.secondary_category)) {
            grouped[link.link_id].secondary_categories.push(link.secondary_category);
          }
          if (!grouped[link.link_id].addons_counts.includes(link.addons_count)) {
            grouped[link.link_id].addons_counts.push(link.addons_count);
          }
          if (!grouped[link.link_id].prices.includes(link.price)) {
            grouped[link.link_id].prices.push(link.price);
          }
          grouped[link.link_id].statuses.push(link.status);
          if (!grouped[link.link_id].minimum_traffic_addon.includes(link.minimum_traffic)) {
            grouped[link.link_id].minimum_traffic_addon.push(link.minimum_traffic);
          }
          if (!grouped[link.link_id].content_approval_addon.includes(link.content_approval)) {
            grouped[link.link_id].content_approval_addon.push(link.content_approval);
          }
          if (!grouped[link.link_id].uk_tld_addon.includes(link.uk_tld)) {
            grouped[link.link_id].uk_tld_addon.push(link.uk_tld);
          }
          if (!grouped[link.link_id].missed_opportunities.includes(link.missed_opportunities)) {
            grouped[link.link_id].missed_opportunities.push(link.missed_opportunities);
          }
          if (!grouped[link.link_id].do_follow.includes(link.do_follow)) {
            grouped[link.link_id].do_follow.push(link.do_follow);
          }
          if (!grouped[link.link_id].traffic.includes(link.traffic)) {
            grouped[link.link_id].traffic.push(link.traffic);
          }
          if (!grouped[link.link_id].spam_score.includes(link.spam_score)) {
            grouped[link.link_id].spam_score.push(link.spam_score);
          }
          if (!grouped[link.link_id].exact_da.includes(link.exact_da)) {
            grouped[link.link_id].exact_da.push(link.exact_da);
          }
          if (!grouped[link.link_id].exact_dr.includes(link.exact_dr)) {
            grouped[link.link_id].exact_dr.push(link.exact_dr);
          }
          if (!grouped[link.link_id].packageOrder.includes(link.packageOrder)) {
            grouped[link.link_id].packageOrder.push(link.packageOrder);
          }
          if (!grouped[link.link_id].live_link.includes(link.live_link)) {
            grouped[link.link_id].live_link.push(link.live_link);
          }
          if (!grouped[link.link_id].publish_date.includes(link.publish_date)) {
            grouped[link.link_id].publish_date.push(link.publish_date);
          }
          if (!grouped[link.link_id].mo_order_type.includes(link.mo_order_type)) {
            grouped[link.link_id].mo_order_type.push(link.mo_order_type);
          }
          if (!grouped[link.link_id].placement_authority.includes(link.placement_authority)) {
            grouped[link.link_id].placement_authority.push(link.placement_authority == null ? 'N/A' : link.placement_authority);
          }
          this.getEditedLinkAddonItems(link).forEach((item) => {
            if (!grouped[link.link_id].addon_items.includes(item)) {
              grouped[link.link_id].addon_items.push(item);
            }
          });
          this.getEditedLinkOldAddonItems(link).forEach((item) => {
            if (!grouped[link.link_id].old_addon_items.includes(item)) {
              grouped[link.link_id].old_addon_items.push(item);
            }
          });
          if (!grouped[link.link_id].authority.includes(link.authority)) {
            grouped[link.link_id].authority.push(link.authority);
          }
          if (!grouped[link.link_id].location.includes(link.location)) {
            grouped[link.link_id].location.push(link.location);
          }
          if (!grouped[link.link_id].sample_post.includes(link.sample_post)) {
            grouped[link.link_id].sample_post.push(link.sample_post);
          }
          if (!grouped[link.link_id].rel_attribute.includes(link.rel_attribute)) {
            grouped[link.link_id].rel_attribute.push(link.rel_attribute);
          }
          if (!grouped[link.link_id].sponsored_tag.includes(link.sponsored_tag)) {
            grouped[link.link_id].sponsored_tag.push(link.sponsored_tag);
          }
          if (!grouped[link.link_id].turnaround_time.includes(link.turnaround_time)) {
            grouped[link.link_id].turnaround_time.push(link.turnaround_time);
          }
          if (!grouped[link.link_id].industry.includes(link.industry)) {
            grouped[link.link_id].industry.push(link.industry);
          }
        }
      });

      return Object.values(grouped);
    },
  },
};
</script>

<style lang="scss" scoped>
/* EditedOrderLinksPage only — table fills card width; scroll inside wrapper (no right-side gap). */
.edited-order-links-page-sec {
  :deep(.edited-links-component) {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  :deep(.edited-links-component .editor-order-table) {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  :deep(.edited-links-component .editor-order-table > .table-responsive) {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
  }

  :deep(.edited-links-component .addon-table) {
    table-layout: auto !important;
    width: 100% !important;
    max-width: 100%;
    box-sizing: border-box;
  }

  :deep(.edited-links-component .addon-table.standard-edited-table) {
    min-width: 1120px;
  }

  :deep(.edited-links-component .addon-table.pp-edited-table) {
    min-width: 1380px;
  }

  :deep(.edited-links-component .addon-table.media-links-edited-table) {
    min-width: 1680px;
  }

  :deep(.edited-links-component .addon-table .text-break-wrapper) {
    align-items: flex-start;
  }

  :deep(.edited-links-component .addon-table td.col-anchor .text-break-wrapper .text-item),
  :deep(.edited-links-component .addon-table td.col-price .text-break-wrapper .text-item) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  :deep(.edited-links-component .addon-table th.col-status),
  :deep(.edited-links-component .addon-table td.col-status) {
    min-width: 100px;
    white-space: nowrap;
  }

  :deep(.edited-links-component .addon-table td.col-status span) {
    white-space: nowrap;
    display: inline-block;
  }
}
</style>
